/* eslint-disable max-len */
/* eslint-disable array-callback-return */
/* eslint-disable consistent-return */
/* eslint-disable react/no-array-index-key */
import React, { useCallback, useEffect, useState } from 'react';
import FormContents from 'components/atoms/Form/FormContents';
import FormField from 'components/atoms/Form/FormField';
import FlexBox from 'components/atoms/FlexBox';
import DatePickerForm from 'components/molecules/DatePickerForm';
import moment from 'moment';
import FormSubmitArea from 'components/atoms/Form/FormSubmitArea';
import PrimaryButton from 'components/atoms/Button';
import RadioSelectForm from 'components/molecules/RadioSelectForm';
import FormLabel from 'components/atoms/Form/FormLabel';
import FlexBoxItem from 'components/atoms/FlexBoxItem';
import BlockUI from 'components/molecules/BlockUi';
import OrganizationFilteredTree from 'components/organismos/organization/OrganizationFilteredTree/OrganizationFilteredTree';
import MonthlyForeCastManagemenTable_new from './MonthlyForeCastManagemenTable_new';
import MonthlySalesManagementTable from './MonthlySalesManagementTable_new';
import useMonthlyReport, { useGetListMonthlyReport } from './hooks';
import MonthlyDiscountSumaryTable_new from './MonthlyDiscountSumaryTable_new';
import { useSelector } from 'react-redux';
import { Store } from 'modules/store';
import useSearchDate from 'hooks/useSearchDate';
import { getOrgTargetDates } from 'utility/orgTargetDateUtil';

const MonthlyReportLayout = () => {
  const fromdate = new Date();

  const searchDate = useSearchDate(moment(fromdate.toString()).format('YYYY-MM-DD'));

  const [targetDateFrom, setTargetDateFrom] = useState<Date | null>(null);
  const [targetDateTo, setTargetDateTo] = useState<Date | null>(null);

  // aggregation (集計) 用に選択日付を元に締日を取得するフック
  // ※ targetDateFrom が選択されていればそれを参照し、未選択なら初期日付(fromdate)を使う
  const searchDateForAggregation = useSearchDate(
    targetDateFrom ? moment(targetDateFrom).format('YYYY-MM-DD') : moment(fromdate).format('YYYY-MM-DD'),
  );

  const [isShowContentAction, setIsShowContentAction] = useState(false);

  const [orgCode, setOrgCode] = useState('all');
  const [orgName, setorgName] = useState('全ての組織');
  const [categoryAry, setCategoryAr] = useState<Array<any> | undefined>(undefined);
  const [getMonthlyComparePrevYear, setMonthlyComparePrevYear] = useState<number>(0);
  const {
    monthlyReport,
    budgetPerfomanceManagementMonthlyReport,
    getIsLoading,
    setIsLoading,
    discountMonthlyReport,
  } = useMonthlyReport(
    String(orgCode),
    targetDateFrom ? moment(targetDateFrom).format('YYYY/MM/DD') : '',
    targetDateTo ? moment(targetDateTo).format('YYYY/MM/DD') : '',
    categoryAry,
    getMonthlyComparePrevYear,
  );
  const targetPeriodData = `対象期間：${targetDateFrom ? moment(targetDateFrom).format('YYYY/MM/DD') : ''}~${
    targetDateTo ? moment(targetDateTo).format('YYYY/MM/DD') : ''
  }`;

  const { action, setAction, ActionType } = useGetListMonthlyReport();

  const getFetchOption = () => {
    setAction(ActionType.getFetchOption);
    setIsShowContentAction(true);
  };

  const getFetchOptionforeCast = () => {
    setAction(ActionType.getFetchOptionforeCast);
    setIsShowContentAction(true);
  };

  const getFetchOptionDiscountSumary = () => {
    setAction(ActionType.getFetchOptionDiscountSumary);
    setIsShowContentAction(true);
  };

  const functionType = 3;
  const staffCode = sessionStorage.getItem('loginUser.staffCode') || '';

  const roleScreen = useSelector((state: Store) => state.auth.roleScreen);

  useEffect(() => {
    if (searchDate.fromDate && searchDate.toDate) {
      setTargetDateFrom(new Date(searchDate.fromDate));
      setTargetDateTo(new Date(searchDate.toDate));
    }
  }, [searchDate]);

  // 集計用の日付を計算
  const getOrgTargetDays = useCallback(() => {
    if (!targetDateFrom || !targetDateTo) {
      return { from: new Date(), to: new Date() };
    }
    return getOrgTargetDates(targetDateFrom, targetDateTo);
  }, [targetDateFrom, targetDateTo]);

  const orgTargetDates = getOrgTargetDays();
  const orgTargetDayFrom = orgTargetDates.from;
  const orgTargetDayTo = orgTargetDates.to;

  return (
    <div>
      <FormContents>
        <div>
          <FlexBox>
            <FlexBoxItem width="100px">
              <FormLabel label="対象期間" />
            </FlexBoxItem>
            <FlexBoxItem>
              <DatePickerForm
                dateFormat="yyyy年MM月dd日"
                label=""
                date={targetDateFrom}
                changeDate={(date: Date) => {
                  if (date !== null) {
                    setTargetDateFrom(date);
                  }
                }}
                isFullWidth={true}
              />
            </FlexBoxItem>
            <FlexBoxItem>
              <span style={{ margin: '0 30px' }}>～</span>
            </FlexBoxItem>
            <FlexBoxItem>
              <DatePickerForm
                dateFormat="yyyy年MM月dd日"
                label=""
                date={targetDateTo}
                changeDate={(date: Date) => {
                  if (date !== null) {
                    setTargetDateTo(date);
                  }
                }}
                isFullWidth={true}
              />
            </FlexBoxItem>
          </FlexBox>
        </div>

        <div>
          {searchDate.fromDate && searchDate.toDate ? (
            <OrganizationFilteredTree
              functionType={functionType}
              staffCode={staffCode}
              // 集計月が当月なら今日を開始/終了日に、それ以外は締日(start/end)を渡す
              targetdayForm={orgTargetDayFrom}
              targetdayTo={orgTargetDayTo}
              addAllItem={true}
              initOrgValue={String(orgCode)}
              orgLabel="店舗名"
              orgCallback={(args: any) => {
                setOrgCode(String(args));
              }}
              orgCategoryCallback={(args: Array<string>) => {
                setCategoryAr(args);
              }}
              orgNameCallback={(arg: any) => {
                setorgName(String(arg));
              }}
              useV5Api={true}
            />
          ) : null}
        </div>
        <FlexBox>
          <FlexBoxItem width="105px">
            <FormLabel label="前年比較対象" />
          </FlexBoxItem>
          <FlexBoxItem>
            <RadioSelectForm
              label=""
              name="monthlyComparePrevYear"
              items={[
                { label: '同曜日', value: '0' },
                { label: '同日', value: '1' },
              ]}
              value={String(getMonthlyComparePrevYear)}
              setValue={(e) => setMonthlyComparePrevYear(Number(e.target.value))}
            />
          </FlexBoxItem>
        </FlexBox>
        <FormField>
          <FormSubmitArea>
            <div style={{ marginRight: '12px' }}>
              <PrimaryButton
                text="売上管理表 "
                ghost={!(isShowContentAction && action === ActionType.getFetchOption)}
                onClick={getFetchOption}
              />
            </div>
            {roleScreen && roleScreen.usabilityGeneralItem1 === 1 && (
              <div style={{ marginRight: '12px' }}>
                <PrimaryButton
                  text="予実管理表"
                  ghost={!(isShowContentAction && action === ActionType.getFetchOptionforeCast)}
                  onClick={getFetchOptionforeCast}
                />
              </div>
            )}
            <PrimaryButton
              text="値引・割引集計表"
              ghost={!(isShowContentAction && action === ActionType.getFetchOptionDiscountSumary)}
              onClick={getFetchOptionDiscountSumary}
            />
          </FormSubmitArea>
        </FormField>

        <div>
          {isShowContentAction && action === ActionType.getFetchOption && (
            <div style={{ marginTop: '30px' }}>
              <div className="row">
                <BlockUI blocking={getIsLoading}>
                  <MonthlySalesManagementTable
                    targetDateFrom={targetDateFrom}
                    targetDateTo={targetDateTo}
                    monthlyReport={monthlyReport}
                    targetPeriodData={targetPeriodData}
                    orgLabel={orgName}
                    setIsLoading={setIsLoading}
                    compareToPreviousYear={getMonthlyComparePrevYear}
                    roleScreen={roleScreen}
                  />
                </BlockUI>
              </div>
            </div>
          )}

          {isShowContentAction && action === ActionType.getFetchOptionforeCast && (
            <div style={{ marginTop: '30px' }}>
              <div className="row">
                <BlockUI blocking={getIsLoading}>
                  <MonthlyForeCastManagemenTable_new
                    setIsLoading={setIsLoading}
                    targetDateFrom={targetDateFrom}
                    targetDateTo={targetDateTo}
                    budgetPerfomanceManagementMonthlyReport={budgetPerfomanceManagementMonthlyReport}
                    targetPeriodData={targetPeriodData}
                    orgLabel={orgName}
                    compareToPreviousYear={getMonthlyComparePrevYear}
                    roleScreen={roleScreen}
                  />
                </BlockUI>
              </div>
            </div>
          )}

          {isShowContentAction && action === ActionType.getFetchOptionDiscountSumary && (
            <div style={{ marginTop: '30px' }}>
              <div className="row">
                <BlockUI blocking={getIsLoading}>
                  <MonthlyDiscountSumaryTable_new
                    setIsLoading={setIsLoading}
                    targetDateFrom={targetDateFrom}
                    targetDateTo={targetDateTo}
                    discountMonthlyReport={discountMonthlyReport}
                    targetPeriodData={targetPeriodData}
                    orgLabel={orgName}
                    compareToPreviousYear={getMonthlyComparePrevYear}
                    roleScreen={roleScreen}
                  />
                </BlockUI>
              </div>
            </div>
          )}
        </div>
      </FormContents>
    </div>
  );
};

export default MonthlyReportLayout;
